import sortDirection from '@enums/sort-direction';

function toComparableString(value) {
    return String(value ?? '').trim();
}

function isNumericLike(value) {
    return /^[-+]?((\d+\.?\d*)|(\.\d+))$/.test(value);
}

export function sortByDate(a, b, order) {
    if (order === sortDirection.ascending) {
        return new Date(a.lastUpdatedOn) - new Date(b.lastUpdatedOn);
    }

    return new Date(b.lastUpdatedOn) - new Date(a.lastUpdatedOn);
}

/**
 * Comparator for natural alphanumeric sort order.
 * Sorts numeric strings numerically ("2" before "10") and text alphabetically (case-insensitive).
 */
export function naturalSort(a, b) {
    const normalisedA = toComparableString(a);
    const normalisedB = toComparableString(b);
    const aIsNumeric = isNumericLike(normalisedA);
    const bIsNumeric = isNumericLike(normalisedB);

    if (aIsNumeric && bIsNumeric) {
        const numericDiff = Number(normalisedA) - Number(normalisedB);

        if (numericDiff !== 0) {
            return numericDiff;
        }
    }

    return normalisedA.localeCompare(normalisedB, undefined, {
        numeric: true,
        sensitivity: 'base',
    });
}
